import { z } from 'zod/v4';

/**
 * UUID of an assembly, the unit of manufacturing within a project: a product such as a PCBA,
 * box build, cable, or system, possibly nested inside a parent assembly. The assembly owns the
 * BOM, and demand, sourcing, manufacturing, and calculation data all attach to it. CAD rendering
 * and analysis endpoints do not accept this ID; their path segments named `assemblyId` or
 * `assembly` take the PCB design ID instead.
 */
export const AssemblyIdRuntype = z
    .string()
    .describe(
        'UUID of an assembly, the unit of manufacturing within a project: a product such as a PCBA, ' +
            'box build, cable, or system, possibly nested inside a parent assembly. The assembly owns the ' +
            'BOM, and demand, sourcing, manufacturing, and calculation data all attach to it. ',
    );

/**
 * UUID of a PCB, the bare board of an assembly. The BOM references it through the design item
 * whose origin type is `PCB` (the PCB id is that design item's origin data). The same UUID
 * identifies the version of the PCB's CAD design, so rendering and analysis endpoints bind it
 * to path segments named `versionId` or `version`, paired with the PCB design ID.
 */
export const PcbIdRuntype = z
    .string()
    .describe(
        'UUID of a PCB, the bare board of an assembly. The BOM references it through the design item ' +
            "whose origin type is `PCB` (the PCB id is that design item's origin data). The same UUID " +
            "identifies the version of the PCB's CAD design, so rendering and analysis endpoints bind it " +
            'to path segments named `versionId` or `version`, paired with the PCB design ID.',
    );

/**
 * UUID of the CAD design container that groups the versions of a PCB's design data; the PCB
 * itself is one such version. Read it from the PCB's `assembly` field. Rendering and analysis
 * endpoints bind it to path segments named `assemblyId` or `assembly`; despite that name, it is
 * a different UUID than the assembly's and the two are not interchangeable.
 */
export const PcbDesignIdRuntype = z
    .string()
    .describe(
        "UUID of the CAD design container that groups the versions of a PCB's design data; the PCB " +
            "itself is one such version. Read it from the PCB's `assembly` field. Rendering and analysis " +
            'endpoints bind it to path segments named `assemblyId` or `assembly`; despite that name, it is ' +
            "a different UUID than the assembly's and the two are not interchangeable.",
    );
